import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Pause } from 'lucide-react';
import { Icon } from '../ui/Icon';

interface HoldSuggestionCardProps {
  message: string;
  onApply: () => void;
  onDismiss: () => void;
  applying?: boolean;
  /**
   * Optional adaptive-guidance paragraph from the most recent
   * /api/ai/adaptive-latest fetch. When present, it renders ABOVE
   * the static `message` as an italic, copper-accented observation
   * sentence (descriptive language only — see prompts/adaptive.ts).
   */
  adaptiveGuidance?: string;
  /** ISO timestamp of the adaptive_guidance row. Reserved for future
   *  "last updated" disclosure; not rendered yet. */
  adaptiveGeneratedAt?: string;
}

export function HoldSuggestionCard({
  message,
  onApply,
  onDismiss,
  applying,
  adaptiveGuidance,
  adaptiveGeneratedAt: _adaptiveGeneratedAt,
}: HoldSuggestionCardProps) {
  const titleId = 'hold-suggestion-title';
  const guidanceId = 'hold-suggestion-guidance';
  const hasGuidance = !!adaptiveGuidance && adaptiveGuidance.trim().length > 0;

  return (
    <Card accentLeft>
      <div className="spread" style={{ marginBlockEnd: 'var(--space-2)' }}>
        <h3
          id={titleId}
          className="text-h3"
          aria-describedby={hasGuidance ? guidanceId : undefined}
        >
          A suggestion based on your last few days
        </h3>
      </div>
      {hasGuidance ? (
        <p
          id={guidanceId}
          className="text-caption muted quote-callout"
        >
          {adaptiveGuidance}
        </p>
      ) : null}
      <p className="copy-block copy-block--loose">{message}</p>
      <div className="row row--wrap">
        <Button onClick={onApply} leftIcon={<Icon icon={Pause} size={16} />} loading={applying}>
          Apply 2-day hold
        </Button>
        <Button variant="tertiary" onClick={onDismiss}>
          Not now
        </Button>
      </div>
    </Card>
  );
}
